import { KidsThemeActor } from "./Actor";
import { KidsBaseTheme } from "./baseTheme";

export class KidsClassicTheme extends KidsBaseTheme {
	constructor() {
		super({
			name: 'classicTheme',
			imagesPath: '/images/kids/themes/classic',
			background: ['sky', 'ground', 'grass']
		});

		this.TREE_TYPES = 6;
		this.TREE_COUNT = 0;

		this.MIN_TREE_SIZE = 200;
		this.MAX_TREE_SIZE = 300;

		this.MIN_TREE_ZINDEX = 1000;
		this.MAX_TREE_ZINDEX = 1500;


		this.CLOUD_TYPES = 2;
		this.CLOUD_COUNT = 10;

		this.MIN_CLOUD_SIZE = 100;
		this.MAX_CLOUD_SIZE = 300;

		this.APP_WIDTH_OFFSET = 2000;

		this.addClouds();
		//	this.addTrees();
	}
	addElements() {
		super.addElements();

		this.addScene();
	}
	addScene() {
		this.addClouds();
	}
	addClouds() {
		this.clouds = [];

		var skyTop = this.appHeight * 0.02, skyBottom = this.appHeight * 0.35;

		for (var i = 0; i < this.CLOUD_COUNT; i += 1) {
			var randomCloud = Math.floor(Math.random() * this.CLOUD_TYPES) + 1, cloudWidth = ((this.MAX_CLOUD_SIZE - this.MIN_CLOUD_SIZE) * Math.random()) + this.MIN_CLOUD_SIZE;

			var cloudActor = new KidsThemeActor(this, 'cloud-' + randomCloud, {
				image: 'cloud-' + randomCloud + '.png ',
				css: {
					'width': cloudWidth,
					'top': Math.floor(Math.random() * (skyBottom - skyTop)) + skyTop,
					'left': (((this.appWidth + cloudWidth + this.APP_WIDTH_OFFSET) / this.CLOUD_COUNT) * i) - this.APP_WIDTH_OFFSET
				}
			});

			this.clouds.push(cloudActor);
		}
	}
}